import {
	CollectionModelCropParameter,
	CollectionModelCropParameterMutator,
	type ModelStateCropParameter,
} from './cropParameter';

export interface ModelStateFreeCropParameter extends ModelStateCropParameter {
	tag: 'free';
	x: number;
	y: number;
	width: number;
	height: number;
}

export class CollectionModelFreeCropParameterMutator extends CollectionModelCropParameterMutator<CollectionModelFreeCropParameter> {
	constructor(cropParameter: CollectionModelFreeCropParameter) {
		super(cropParameter);
	}

	init(x: number, y: number, width: number, height: number) {
		this.cropParameter.cropParameterState.Mutator.create('free');
		this.setCrop(x, y, width, height);
	}

	setCrop(x: number, y: number, width: number, height: number) {
		const state = this.getValue();
		state.x = x;
		state.y = y;
		state.width = width;
		state.height = height;
		this.setValue(state);
	}
}

export class CollectionModelFreeCropParameter extends CollectionModelCropParameter<ModelStateFreeCropParameter> {
	static state(id: string): ModelStateFreeCropParameter {
		return {
			id,
			tag: 'free',
			x: 0,
			y: 0,
			width: 0,
			height: 0,
		};
	}

	static readonly TAG = 'free' as const;
	readonly tag = CollectionModelFreeCropParameter.TAG;
	override Mutator = new CollectionModelFreeCropParameterMutator(this);

	static isFree(t: CollectionModelCropParameter): t is CollectionModelFreeCropParameter {
		return t.tag === CollectionModelFreeCropParameter.TAG;
	}

	get x(): number {
		const state = this.state;
		return state.x;
	}

	get y(): number {
		const state = this.state;
		return state.y;
	}

	get width(): number {
		const state = this.state;
		return state.width;
	}

	get height(): number {
		const state = this.state;
		return state.height;
	}
}
